// Radio button assignments (Admin > Radios > Edit > Radio-Specific Settings > Button
// assignments). The server lists only the radio's user-changeable Model Catalog buttons and, per
// button, the actions it may be assigned (model feature capabilities and button events already
// applied) - see documentation/protocol.md "Radio button assignments". It also enforces the same
// rules on save, so these helpers only shape the UI and the request.
import type { ButtonAssignmentAction, RadioButtonAssignments } from '../../services/admin';

/** '' = no stored assignment: the button keeps its built-in behaviour. */
export const DEFAULT_ASSIGNMENT = '';

export type AssignmentChoices = Record<string, string>;

/** The current choice per button_function_id. */
export const initialChoices = (data: RadioButtonAssignments): AssignmentChoices =>
  Object.fromEntries(data.buttons.map((b) => [b.button_function_id, b.action_code ?? DEFAULT_ASSIGNMENT]));

/** The actions offered for a button, in catalog order, limited to what the server allows. */
export const actionOptions = (allowed: string[], actions: ButtonAssignmentAction[]): ButtonAssignmentAction[] =>
  actions.filter((a) => allowed.includes(a.code));

/** The PUT body: every listed button with an explicit action; default buttons are left out. */
export const assignmentPayload = (data: RadioButtonAssignments, choices: AssignmentChoices) =>
  data.buttons
    .map((b) => ({ button_function_id: b.button_function_id, action_code: choices[b.button_function_id] ?? DEFAULT_ASSIGNMENT }))
    .filter((a) => a.action_code !== DEFAULT_ASSIGNMENT);

export const choicesChanged = (data: RadioButtonAssignments, choices: AssignmentChoices): boolean =>
  data.buttons.some((b) => (b.action_code ?? DEFAULT_ASSIGNMENT) !== (choices[b.button_function_id] ?? DEFAULT_ASSIGNMENT));
